<script setup>
import { ref, computed, onMounted } from "vue";
import { addDays, subDays, format } from "date-fns";
import ru from "date-fns/locale/ru/index.js";
import { useRequestsStore } from "@/stores/storeRequests";
import { useSettingsStore } from "@/stores/storeSettings";

const storeRequests = useRequestsStore();
const storeSettings = useSettingsStore();

const courtId = ref(sessionStorage.getItem('courtIdToken'))

const currentDate = ref(new Date());
const selectedDate = ref("");

const mobileCountDaysWeek = computed(() => storeSettings.widthWindow > 576 ? 8 : 5)

const weekDays = computed(() => {
  	return Array.from({ length: mobileCountDaysWeek.value }, (_, i) => addDays(currentDate.value, i))
})

const formattedMonth = computed(() => format(currentDate.value, "LLLL yyyy", { locale: ru }));

function nextWeek() {
	currentDate.value = addDays(currentDate.value, mobileCountDaysWeek.value );
}
function prevWeek() {
	currentDate.value = subDays(currentDate.value, mobileCountDaysWeek.value );
}

async function selectDay(day) {
	selectedDate.value = format(day, "yyyy-MM-dd");
	const nextDay = addDays(day, 1)
	const nextDayFormatted = format(nextDay, "yyyy-MM-dd")
	const parametrs = {
        court_id: courtId.value, 
        start_date: selectedDate.value,
        end_date: nextDayFormatted,
        limit: 24,
        offset: 0
    }
    await storeRequests.getCourtsSlots(parametrs);
	
}

function isSelected(day) {
	return format(day, "yyyy-MM-dd") === selectedDate.value;
}
function shortDayName(day) {
	const map = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"]
  	return map[day.getDay()]
}

onMounted(() => {
  	selectedDate.value = format(new Date(), 'yyyy-MM-dd')
})

</script>

<template>
	<div class="week">
		
		<div class="week__month">{{ formattedMonth }}</div>
		<div class="week__week">
			<div class="week__controls">
				<button @click="prevWeek" class="week__prev week__btn">
					<svg width="40" height="40"><use href="#slider__prev"></use></svg>
				</button>
				<button @click="nextWeek" class="week__next week__btn">
					<svg width="40" height="40"><use href="#slider__next"></use></svg>
				</button>
			</div>
			<ul class="week__list">
				<li 
					v-for="day in weekDays" :key="day.toISOString()" 
					class="week__item" 
					:class="{ active: isSelected(day), 'weekend-day': [0, 6].includes(day.getDay()) }" 
					@click="selectDay(day)"
				>
					<span>{{ shortDayName(day) }}</span>
					<span>{{ format(day, "dd") }}</span>
				</li>
			</ul>
		</div>

	</div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.week__month {
	font-weight: 500;
	font-size: 2.4rem;
	line-height: 120%;
	text-align: center;
	color: var(--text-inverse-100);
	&::first-letter {
		text-transform: uppercase;
	}
}
.week__week {
	position: relative;
}
.week {
	display: grid;
	gap: 2.7rem;
}
.week__controls {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 115%;
	display: flex;
	justify-content: space-between;
    @media (max-width: vars.$xx) {
        width: 100%;
    }
}
.week__prev {
}
.week__next {
}
.week__btn {
	svg {
		width: 4rem;
		height: 4rem;
	}
}
.week__list {
	position: relative;
	display: grid;
	grid-template-columns: repeat(8, 1fr);
	gap: 1.2rem;
    @media (max-width: vars.$xx) {
        grid-template-columns: repeat(5, 1fr);
        gap: .8rem;
        max-width: 80%;
        margin-left: auto;
        margin-right: auto;
    }
    @media (max-width: vars.$x480) {
        max-width: 75%;
    }
}
.week__item {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	// gap: 5px;
	border: 1px solid var(--border-default-1);
	padding: 2.5rem 1rem;
	cursor: pointer;
	transition: opacity var(--transition) ease-in;

	font-weight: 500;
	font-size: 2rem;
	line-height: 120%;
	text-align: center;
	color: var(--text-inverse-100);
    @media (max-width: vars.$x480) {
        padding: 8px;
        font-size: 1.6rem;
    }

	@media (hover: hover) {
		&:hover {
			opacity: 0.5;
		}
	}

	span {
		&:first-child {
			text-transform: uppercase;
		}
	}
	&.active {
		background: var(--fill-inverse-1);
		color: var(--text-default-100);
		&.weekend-day {
			background-color: rgba(243, 101, 101, 1);
			color: #fff;
		}
	}
    &:nth-child(6), &:nth-child(7), &:nth-child(8) {
        @media (max-width: vars.$xx) {
            display: none;
        }
    }

	&.weekend-day {
		border-color: rgba(243, 101, 101, 1);
		color: rgba(243, 101, 101, 1);
	}
}
</style>
